exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".label{\n    font-weight: bold;\n    margin-right: 15px;\n}", "", {"version":3,"sources":["/home/dev/bitool-new/client/app/main/reports/product-wise-report/productWiseReport.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;CACtB","file":"productWiseReport.css","sourcesContent":[".label{\n    font-weight: bold;\n    margin-right: 15px;\n}"],"sourceRoot":""}]);

// exports
